import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_GET_ITEM_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- USERS
// ---------------------------------

const ENDPOINT_USERS = '/admin/users';

const logger = LoggerService.getInstance();

/**
 * Requete le endpoint users
 * Récupère la liste des utilisateurs
 * @param param0
 */
const get = async ({accessToken,page}:I_ACCESS_TOKEN_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - users - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_USERS}${APP_CONFIG.ENDPOINT_SUFFIX}${page ? '?page=' + page : ''}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint user
 * Récupère l'utilisateur
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - users - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_USERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_USER_POST_PARAMS {
  accessToken: string,
  email: string,
  id_osac: string,
  roles: string,
  firstname: string,
  lastname: string,
  sso: boolean,
  password: string,
}
/**
 * Requete le endpoint users POST
 * Ajoute un utilisateur
 * @param param0
 * @returns
 */
const post = async ({accessToken,email,id_osac,roles,firstname,lastname,sso,password}:I_USER_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - users - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      email: encodeURIComponent(email.trim()),
      id_osac: encodeURIComponent(id_osac.trim()),
      roles: encodeURIComponent(roles),
      firstname: encodeURIComponent(firstname.trim()),
      lastname: encodeURIComponent(lastname.trim()),
      password: encodeURIComponent(password.trim()),
      sso,
    })
  };
  const URL = ENDPOINT_USERS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint user DELETE
 * Supprime un utilisateur
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - users - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_USERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_USER_PUT_PARAMS {
  accessToken: string,
  id: number,
  email: string,
  id_osac: string,
  roles: string,
  firstname: string,
  lastname: string,
  sso: boolean,
}
/**
 * Requete le endpoint activity-types PUT
 * Met à jour un type d'activite
 * @param param0
 * @returns
 */
const put = async ({accessToken,id,email,id_osac,roles,firstname,lastname, sso}:I_USER_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - users - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      email: encodeURIComponent(email.trim()),
      roles: encodeURIComponent(roles),
      id_osac: encodeURIComponent(id_osac.trim()),
      firstname: encodeURIComponent(firstname.trim()),
      lastname: encodeURIComponent(lastname.trim()),
      sso
    })
  };
  const URL = `${ENDPOINT_USERS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const usersEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
};

export default usersEndpoints;
